import { t } from "../i18n/t.js";
import { AFTERNOON_FROM, EVENING_FROM } from "../schedule/windows.js";
import { DayWord, moveOn } from "./need.js";
/**
 * When the worker should come, once the day is known: one chip per hour the household can start from, from
 * `FIRST_HOUR` to `LAST_HOUR` (on today, only hours still ahead), and "Any time" (ADR 0050 §1). The hour is kept as
 * the owner reads it ("2 pm", "दोपहर 2 बजे"), as a typed time is: the window the agents negotiate is read from it
 * (`windowOf`), and the worker reads the hour itself. A time said with the day ("tomorrow 10 am") skips the question.
 */
/** The first and last hour a job may start at, on the 24-hour clock. */
export const FIRST_HOUR = 7;
export const LAST_HOUR = 20;
/** The time of a need whose household said any time that day is fine: asked, and nothing to read a window from. */
export const ANY_TIME = "";
/** A chip's value for an hour ("at:14"), and for any time. */
const HOUR_PICK = "at:";
export const ANY_TIME_PICK = "any_time";
const NOON = 12;
/** The hour's words in the owner's language, by the part of the day it is in. */
function hourWords(lang, hour) {
    const key = hour < AFTERNOON_FROM ? "hour.morning" : hour < EVENING_FROM ? "hour.afternoon" : "hour.evening";
    return t(lang, key, { h: hour > NOON ? hour - NOON : hour });
}
const startsToday = (s) => s.draft.day === DayWord.today || s.draft.day === s.config.today;
/** The hours a household may pick: every one from the first to the last, or on today those after the phone's hour. */
export function hoursOpen(s) {
    const after = startsToday(s) && s.config.hour !== undefined ? s.config.hour + 1 : FIRST_HOUR;
    const from = Math.max(FIRST_HOUR, after);
    return Array.from({ length: Math.max(0, LAST_HOUR - from + 1) }, (_, i) => from + i);
}
/** The day is set and the household has not said when in it: the hour is asked next. */
export const needsHour = (d) => d.day !== undefined && d.time === undefined;
/** "What time should they come?", with a chip for each hour open and "Any time" last. */
export function hourPrompt(s) {
    const own = s.config.own;
    const choices = [
        ...hoursOpen(s).map((h) => ({
            value: `${HOUR_PICK}${h}`,
            key: "when.hour",
            params: { time: hourWords(own, h) },
        })),
        { value: ANY_TIME_PICK, key: "when.any_time" },
    ];
    return { lines: [{ key: "need.ask.hour" }], choices, hints: choices.map((c) => t(own, c.key, c.params)) };
}
/** A tapped hour, or any time: the need moves on with its time set; any other value changes nothing. */
export function chooseHour(s, value) {
    if (value === ANY_TIME_PICK)
        return moveOn(s, { ...s.draft, time: ANY_TIME });
    const hour = value.startsWith(HOUR_PICK) ? Number(value.slice(HOUR_PICK.length)) : Number.NaN;
    if (!hoursOpen(s).includes(hour))
        return undefined;
    return moveOn(s, { ...s.draft, time: hourWords(s.config.own, hour) });
}
//# sourceMappingURL=need-time.js.map